<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="新增"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="类型">
          <a-select
            v-decorator="['type_value', {
              rules: [
                { required: true, message: '请选择类型' }
              ]
            }]"
            :loading="loadingCommonTypeTypeOptions"
            @change="handleCommonTypeChange"
            allow-clear
          >
            <a-select-option
              v-for="option in commonTypeTypeOptions"
              :key="option.slug"
              :value="option.value"
              :is-sub-type-has-slug="option.is_sub_type_has_slug"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入名称' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item v-if="isShowSubTypeSlug" label="Slug">
          <a-select
            v-decorator="['sub_type_slug', {
              rules: [
                { required: true, message: '请选择Slug' }
              ]
            }]"
            :loading="loadingCommonTypeSubTypeSlugOptions"
            allow-clear
          >
            <a-select-option
              v-for="value in commonTypeSubTypeSlugOptions"
              :key="value"
              :value="value"
            >
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="说明">
          <a-textarea
            v-decorator="['description', {
              rules: [
                { max: 200, message: '最多200个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { createCommonType, findCommonTypeTypeOptions, findCommonTypeSubTypeSlugOptions } from '@/api/common_type'

export default {
  name: 'NewCommonType',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'common_type' }),
      data: {},
      loadingCommonTypeTypeOptions: false,
      commonTypeTypeOptions: [],
      commonTypeTypeOptionsMap: {},
      isShowSubTypeSlug: false,
      loadingCommonTypeSubTypeSlugOptions: false,
      commonTypeSubTypeSlugOptions: [],
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.form.getFieldDecorator('keys', { initialValue: [0], preserve: true })

    this.fetchCommonTypeTypeOptions()
  },
  methods: {
    fetchCommonTypeTypeOptions() {
      this.loadingCommonTypeTypeOptions = true
      findCommonTypeTypeOptions().then((res) => {
        if (res.code === 0) {
          this.commonTypeTypeOptions = res.data
          res.data.forEach((element) => {
            this.commonTypeTypeOptionsMap[element.id] = element
          })
        }
        this.loadingCommonTypeTypeOptions = false
      })
    },

    handleCommonTypeChange(value, e) {
      console.log(e)
      this.isShowSubTypeSlug = false
      this.commonTypeSubTypeSlugOptions = []

      if (e.data.attrs['is-sub-type-has-slug']) {
        this.isShowSubTypeSlug = true
        this.loadingCommonTypeSubTypeSlugOptions = true
        findCommonTypeSubTypeSlugOptions(e.key).then((res) => {
          if (res.code === 0) {
            this.commonTypeSubTypeSlugOptions = res.data
          }
          this.loadingCommonTypeSubTypeSlugOptions = false
        })
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = {
            ...values
          }

          createCommonType(data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.device-shape{
  max-height: 280px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
}
</style>
